import Modal from 'LuxKit/Modal/Modal'
import Table from 'LuxKit/Tables/Table'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'

function LoyaltyLandingPageMovingTiersModal() {
  const intl = useIntl()

  const modalTitle = intl.formatMessage({
    id: 'DXVF8PXM6a',
    defaultMessage: 'Moving through the tiers',
    description: 'Title for the tier progression details modal',
  })
  const modalBody = intl.formatMessage({
    id: 'mhudR5ZkC7',
    defaultMessage: 'The below is what you’ll need to achieve within your calendar year to progress to the next tier or retain your current tier.',
    description: 'Explanation of tier progression requirements in the modal',
  })
  const tierHeader = intl.formatMessage({
    id: 'e6JLj6kfUl',
    defaultMessage: 'Tier',
    description: 'Table column header for loyalty tier name',
  })
  const statusCreditsHeader = intl.formatMessage({
    id: '5f3glCTwRt',
    defaultMessage: 'Status Credits',
    description: 'Table column header for required Status Credits count',
  })
  const nightsHeader = intl.formatMessage({
    id: 'q7CPUyAJ4G',
    defaultMessage: 'Number of nights',
    description: 'Table column header for required number of nights stayed',
  })
  const silverLabel = intl.formatMessage({
    id: 'P/qpW0RB/O',
    defaultMessage: 'Silver',
    description: 'Silver tier name in tier progression table',
  })
  const goldLabel = intl.formatMessage({
    id: 'CBdNij17aP',
    defaultMessage: 'Gold',
    description: 'Gold tier name in tier progression table',
  })
  const platinumLabel = intl.formatMessage({
    id: 'XQkhVoCIeQ',
    defaultMessage: 'Platinum',
    description: 'Platinum tier name in tier progression table',
  })

  return <Modal size="S" title={modalTitle}>
    <Group direction="vertical" gap={16}>
      <BodyText variant="medium">
        {modalBody}
      </BodyText>
      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {tierHeader}
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {statusCreditsHeader}
              </BodyText>
            </TableHeaderCell>
            <TableHeaderCell>
              <BodyText variant="small" weight="bold">
                {nightsHeader}
              </BodyText>
            </TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {silverLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                200
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                10
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {goldLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                600
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                20
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>
              <BodyText variant="small" weight="bold">
                {platinumLabel}
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                1,000
              </BodyText>
            </TableBodyCell>
            <TableBodyCell>
              <BodyText variant="small">
                30
              </BodyText>
            </TableBodyCell>
          </TableBodyRow>
        </TableBody>
      </Table>
    </Group>
  </Modal>
}

export default LoyaltyLandingPageMovingTiersModal
